import { useEffect, useState } from "react";
import { BACKEND_URL } from "./../backendconfig";

const api = `${BACKEND_URL.replace(/\/+$/, "")}/admin-profile-api.php`;

async function readResponse(response) {
  let data;

  try {
    data = await response.json();
  } catch {
    throw new Error("Invalid API response. Check admin-profile-api.php.");
  }

  if (!response.ok || !data.ok) {
    throw new Error(data.message || "Unable to process request.");
  }

  return data;
}

export function useAdminAccount() {
  const [account, setAccount] = useState(null);
  const [csrf, setCsrf] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    async function load() {
      try {
        const response = await fetch(api, {
          credentials: "include",
          cache: "no-store",
          signal: controller.signal,
        });

        const data = await readResponse(response);

        if (!controller.signal.aborted) {
          setAccount(data.admin);
          setCsrf(data.csrf);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setLoadError(error.message);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }

    load();
    return () => controller.abort();
  }, []);

  async function save(action, fields) {
    const response = await fetch(api, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...fields, action, csrf }),
    });

    return readResponse(response);
  }

  return { account, loading, loadError, save };
}
